/* MARCA | 20/08/2026 | Scent Profile modal open/close logic with Add to Cart integration */

class ScentProfileModal extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.scent-profile-modal__overlay');
    this.closeBtn = this.querySelector('.scent-profile-modal__close');
    this.atcBtn = this.querySelector('[data-scent-profile-atc]');
    this.trigger = null;
  }

  connectedCallback() {
    const triggerId = this.dataset.triggerId;
    this.trigger = document.getElementById(triggerId);

    if (this.trigger) {
      this.trigger.addEventListener('click', this.open.bind(this));
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
    }

    if (this.atcBtn) {
      this.atcBtn.addEventListener('click', this.addToCart.bind(this));
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) this.close();
    });
  }

  isOpen() {
    return this.overlay && this.overlay.classList.contains('is-active');
  }

  open() {
    if (!this.overlay) return;
    this.overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    this.closeBtn && this.closeBtn.focus();
  }

  close() {
    if (!this.overlay) return;
    this.overlay.classList.remove('is-active');
    document.body.style.overflow = '';
    this.trigger && this.trigger.focus();
  }

  addToCart() {
    const productInfo = this.closest('product-info');
    if (!productInfo) return;

    const form = productInfo.querySelector('form[action*="/cart/add"]');
    if (form) {
      const submitBtn = form.querySelector('[type="submit"], button[name="add"]');
      if (submitBtn) {
        this.close();
        submitBtn.click();
      }
    }
  }
}

if (!customElements.get('scent-profile-modal')) {
  customElements.define('scent-profile-modal', ScentProfileModal);
}
